import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';

import {
  IndividualCostWrapperStyled,
  TotalCostWrapperStyled,
  TotalCostStyled,
  TotalCostTextStyled,
} from './PerPayPeriodHeaderStyled';
import { selectPerPayPeriodText } from 'enrollment/services';
import {
  getPremiumStyled,
  RETURN_DISPLAY,
  RETURN_VALUE_ONLY,
} from 'enrollment/utils';

interface PerPayPeriodHeaderProps {
  totalSubPremium: number;
  totalOrgPremium: number;
  additionalClasses?: string;
}

export const PerPayPeriodHeader = ({
  totalSubPremium,
  totalOrgPremium,
  additionalClasses,
}: PerPayPeriodHeaderProps) => {
  const { t } = useTranslation('pages.benefits');
  const perPayText = useSelector(selectPerPayPeriodText);
  const isScreenSmall = window.innerWidth < 744;

  return (
    <div className={`row ${additionalClasses}`}>
      <IndividualCostWrapperStyled
        className={`col ${!isScreenSmall ? 'border-right pr-4' : 'pt-2'}`}
      >
        <p
          dangerouslySetInnerHTML={{
            __html: t('yourCostPpp', {
              value: totalSubPremium.toLocaleString('en-US', {
                style: 'currency',
                currency: 'USD',
              }),
              pppText: perPayText,
            }),
          }}
        ></p>
        {Number(totalOrgPremium.toFixed(2)) > 0 && (
          <p
            dangerouslySetInnerHTML={{
              __html: t('erCostPpp', {
                value: totalOrgPremium.toLocaleString('en-US', {
                  style: 'currency',
                  currency: 'USD',
                }),
              }),
            }}
          ></p>
        )}
      </IndividualCostWrapperStyled>
      <TotalCostWrapperStyled className={`col ${isScreenSmall && 'pb-2'}`}>
        <TotalCostStyled>
          {getPremiumStyled({
            premium: String(totalSubPremium),
            valueOnly: isScreenSmall ? RETURN_VALUE_ONLY : RETURN_DISPLAY,
          })}
        </TotalCostStyled>
        <TotalCostTextStyled>
          {isScreenSmall ? `${t('totalCost')}` : `${perPayText}`}
        </TotalCostTextStyled>
      </TotalCostWrapperStyled>
    </div>
  );
};
